import React, { useEffect } from 'react';
import { globalBigQueryReporter, globalGrafanaReporter, globalMixpanelReporter } from '../../events';
import { InitialStepTitle } from '../InitialStepTitle';
import { SocialSigningForm } from '../SocialSigningForm';

export const InitialStep = () => {
    useEffect(() => {
        globalGrafanaReporter.count('identification.%{platform}.initial.show');
        globalMixpanelReporter.send('Identification - Initial - Show');
        globalBigQueryReporter.send('identification.initial.show');
    }, []);

    return (
        <>
            <InitialStepTitle />
            <SocialSigningForm />
        </>
    );
};
